app.controller("ExamsManagerDaysController", [
    "$scope", "ExamsManagerService", "$stateParams", "$state", "$uibModal", "ConfirmModal", "toastr", "StaticData",
    function ($scope, ExamsManagerService, $stateParams, $state, $uibModal, ConfirmModal, toastr, StaticData) {
        $scope.chosenExamDay = new Date();
        $scope.selectedExamDay = null;
        $scope.examHalls = [];
        var levels = null;
        $scope.fetchDays = function () {
            ExamsManagerService.fetchExamDays().then(function (data) {
                $scope.examDays = data;
                console.log(data);
                if ($scope.examDays.length) {
                    $scope.selectedExamDay = $scope.examDays[0];
                    $scope.fetchSessions($scope.selectedExamDay);
                }
            });
        };
        $scope.fetchDays();

        $scope.dayPopup = {opened: false};
        $scope.openDayPopup = function () {
            $scope.dayPopup.opened = true;
        };
        $scope.dayPopupOptioons = {};

        $scope.chooseDay = function (examDay) {
            console.log(examDay);
            $scope.selectedExamDay = examDay;
            $scope.fetchSessions($scope.selectedExamDay);
        };

        $scope.addDay = function () {
            // return console.log($scope.chosenExamDay);
            ExamsManagerService.addExamDay({day: $scope.chosenExamDay}).then(function () {

                $scope.fetchDays();
                toastr.success('', 'დღე წარმატებით დაემატა');
            });
        };

        $scope.removeDay = function (examDay) {
            console.log(examDay);
            ConfirmModal.show({
                title: "დღის წაშლა",
                message: "გსურთ ამ დღის სიიდან წაშლა?"
            }).result.then(function () {
                ExamsManagerService.removeExamDay({
                    examDayId: examDay._id
                }).then(function (result) {
                    toastr.success('', 'დღე წარმატებით წაიშალა სიიდან');
                    $scope.fetchDays();
                });
            });
        };

        $scope.fetchSessions = function (examDay) {
            console.log("day");
            console.log(examDay);
            $scope.sessions = [];
            StaticData.getItemsByKey("levels").then(function (levelList) {
                levels = levelList;
                console.log(levels);
                ExamsManagerService.fetchDaySessions({dayId: examDay._id}).then(function (data) {
                    data.forEach(function (el) {
                        el.levelText = _.chain(levels)
                            .filter({_id: el.level})
                            .head().value().name;
                        // console.log(el.levelText);
                    });
                    $scope.sessions = data;
                    console.log(data);
                });
            });

        };

        $scope.addSession = function () {
            $uibModal.open({
                controller: "ExamsManagerAddSessionController",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-add-session.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {examDay: $scope.selectedExamDay};
                    }
                }
            }).result
                .then(function (result) {
                    $scope.fetchSessions($scope.selectedExamDay);
                }, function () {
                });
        };


        $scope.removeSession = function (examSession) {
            console.log(examSession);
            ConfirmModal.show({
                title: "დღის წაშლა",
                message: "გსურთ ამ დღის სიიდან წაშლა?"
            }).result.then(function () {
                ExamsManagerService.removeSession({
                    examSessionId: examSession._id
                }).then(function (result) {
                    toastr.success('', 'დღე წარმატებით წაიშალა სიიდან');
                    $scope.fetchSessions($scope.selectedExamDay);
                });
            });
        };
    }
]);
